import { useI18n } from '../../../hooks/useI18n';

export const useChannelsTexts = () => {
    const i18n = useI18n();

    return {
        title: i18n('home__tv_channels__title'),
        subtitle: i18n('home__allplay__tv_channels__subtitle'),
        subtitleMaxWidth: undefined,
        description: i18n('home__tv_channels__description'),
    };
};
